import { render } from "./RecordComponent.vue?vue&type=template&id=5874274b&scoped=true&lang=html"
import script from "./RecordComponent.vue?vue&type=script&lang=js"
export * from "./RecordComponent.vue?vue&type=script&lang=js"

import "./RecordComponent.vue?vue&type=style&index=0&id=5874274b&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5874274b"]])

export default __exports__